import React from 'react'
import PropTypes from 'prop-types'

const ReferredCard = (props) => (
  <div className="list-group-item d-flex flex-column w-100 align-items-start">

    <div className="d-flex w-100 justify-content-between">
      <h5 className="mb-2">{props.name} • {props.companyName}</h5>
      <small>{props.subscribed ? 'Efetivado' : 'Pendente'}</small>
    </div>
    <small className="mb-0">{props.phone}</small>
    <small className="mb-0">{props.email}</small>
  </div>
)

ReferredCard.propTypes = {
  email: PropTypes.string,
  companyName: PropTypes.string,
  name: PropTypes.string,
  phone: PropTypes.string,
  subscribed: PropTypes.bool,
}

export default ReferredCard



// WEBPACK FOOTER //
// ./client/components/ReferredCard.js